import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import tasksReducer from './slices/tasksSlice';
import topicsReducer from './slices/topicsSlice';
import timerReducer from './slices/timerSlice';
import blogsReducer from './slices/blogsSlice';
import analyticsReducer from './slices/analyticsSlice';
import uiReducer from './slices/uiSlice';
import tracksReducer from './slices/tracksSlice';
import mapReducer from './slices/mapSlice';
import plannerReducer from './slices/plannerSlice';
import momentumReducer from './slices/momentumSlice';
import notesReducer from './slices/notesSlice';
import artifactsReducer from './slices/artifactsSlice';
import tagsReducer from './slices/tagsSlice';
import socialReducer from './slices/socialSlice';
import aiReducer from './slices/aiSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    tasks: tasksReducer,
    topics: topicsReducer,
    timer: timerReducer,
    blogs: blogsReducer,
    analytics: analyticsReducer,
    ui: uiReducer,
    tracks: tracksReducer,
    map: mapReducer,
    planner: plannerReducer,
    momentum: momentumReducer,
    notes: notesReducer,
    artifacts: artifactsReducer,
    tags: tagsReducer,
    social: socialReducer,
    ai: aiReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['timer/tick'],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
